import React from "react"
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks"
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { IncidentCommentDeleteCommand } from "../../../../../services/varianceService/commands/IncidentCommentDeleteCommand";
import { useIncidentCommentDeleteMutation } from "../../../../../services/varianceService/variance-api";
import { toggleIncidentCommentDeleteModal } from "../../../../../app/slices/VarianceModuleSlice";
import { useMyProfileQuery } from "../../../../../services/profileService/profile-api";

function IncidentCommentDeleteDialog(){
    const dispatch = useAppDispatch();
    const { data } = useMyProfileQuery(); 
    const modalOpen = useAppSelector((state)=>state.varianceModule.IncidentCommentDeleteModal);
    const selectedComment = useAppSelector((state)=>state.varianceModule.SelectedCommentForDelete);
    const varianceId = useAppSelector((state)=>state.varianceRequest.varianceRequest.id);
    const [deleteComment] = useIncidentCommentDeleteMutation();
    
    const confirmDelete = ()=>{
        if (selectedComment) {
            let command = new IncidentCommentDeleteCommand(
                varianceId!,
                selectedComment.commentId.toString(),
                data!.identity!
            );
            deleteComment(command);
        }
    }

    const handleClose = () => {
        dispatch(toggleIncidentCommentDeleteModal(null));
    }

    return <Dialog open={modalOpen} onClose={handleClose}>
        <DialogTitle>Delete Comment</DialogTitle>
        <DialogContent>
            <Typography variant="body1" sx={{ marginBottom: 2 }}>
                Are you sure you want to delete this comment?
            </Typography>
            {selectedComment && (
                <Typography 
                    variant="body2" 
                    sx={{ 
                        padding: 2, 
                        backgroundColor: '#f5f5f5', 
                        borderRadius: 1,
                        fontStyle: 'italic'
                    }}
                >
                    "{selectedComment.text}"
                </Typography>
            )}
            <Typography variant="caption" color="error" sx={{ marginTop: 2, display: 'block' }}>
                This action cannot be undone.
            </Typography>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button 
                onClick={()=>{confirmDelete();handleClose();}} 
                color="error"
                variant="contained"
            >
                Delete
            </Button>
        </DialogActions>
    </Dialog>
}

export {IncidentCommentDeleteDialog}
